<template>
    <div class="modal-content wallet_edit_stake_modal">
        <div class="modal-header modal_cmn_header">
            <h5 class="modal-title">{{$t('delete-account', 'Delete Account')}}</h5>
        </div>
        <div class="modal-body">
            <div class="delete_acc_txt_cl">
                <div class="modal-info">
                    <img src="@/assets/images/exit.png" alt="">
                </div>
                <h3>Delete Account?</h3>
                <h4>{{ $t('do-you-want-to-delete-account', 'Do you want to delete account') }}?</h4>
                
                <div class="delete_acc_btn">
                    <button  @click="$emit('close')" type="button" id="closeBtn" class="cmn_ftr_btn cancel_btn_cl" data-bs-dismiss="modal">{{ $t('cancel', 'Cancel') }}</button>
                    <button @click="deleteServiceCall()" type="button" class="cmn_ftr_btn yes_btn_cl">{{ $t('yes', 'Yes') }}</button>
                </div>
            </div>
        </div>
    
    </div>
</template>

<script>
import { removeAccount } from '../services/walletWithdraw'
export default {
    name: 'DeleteAccount',
    props: ['item'],
    emits: ['close', 'yes-click'],    
    methods:{
        async deleteServiceCall() {
            let response = await removeAccount(this.item.client_account_id)
            if(response) {
                this.$emit('yes-click');
            }
        }
    },
};
</script>